import Header from './components/Header';
import Footer from './components/Footer';
import bg from './assets/Unvi.jpg';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Home from './pages/Home'; 
import ExamPage from './pages/ExamPage';
import Instructions from './pages/Instructions';
import Login from './pages/Login';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { maxios } from './store/maxios';
import axios from 'axios';
import ExamSubmittedAlready from './components/exam/ExamSubmittedAlready';
import authService from './services/auth.service';
import IpBlocked from './pages/IpBlocked';
import NoNetwork from './pages/NoNetwork';
import ExamCompleted from './components/exam/ExamCompleted';



function App() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const user = useSelector(state=>state.auth.user)
  localStorage.setItem("submitted",true)
  const data = useSelector(state=>state.auth.data)
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const loggedIn = useSelector((state) => state.auth.logged_in);
   const [ipAllowed,setIpAllowed]=useState(true);
    const loadIpStatus = async()=>{
      const ipStatus =await authService.logIp();
    
   
     setIpAllowed(ipStatus.status);
    }

    useEffect(()=>{
      if(isOnline!=true){
        return
      }
   loadIpStatus()
    },[])
    
   
   useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
 
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);  

  const loadData = async () => {
  
   
   if(isOnline!=true){
    return;
   }

   
    try {
  
      const response = await maxios.get('/get-data-list');
      console.log(response.data)
      if(response.data.error==true){
        alert(response.data.message)
      }
      if (response.data?.user) {
        dispatch({ type: 'SET_USER', payload: response.data.user });
        dispatch({ type: 'SET_LOGIN' });
        
      } else {
       dispatch({ type: 'SET_LOGOUT' });
      }
      dispatch({type:'SET_EXAM',payload:response.data.exam})
      dispatch({ type: 'SET_DATA', payload: response.data });
    } catch (error) {
      console.error('Error loading data:', error);
     dispatch({ type: 'SET_LOGOUT' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);
  const [timeLeft, setTimeLeft] = useState({
    days:0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  function calculateTimeLeft() {
    const now= new Date();
    const istTime =new Date(now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
    if(data.exam){ 
    const examTime = new Date(data.exam.exam_date);
    const diffInSeconds = Math.floor((examTime -istTime) / 1000);
     

    if (diffInSeconds <= 0) {
      return { hours: 0, minutes: 0, seconds: 0 };
    }

    return {
      days: Math.floor(diffInSeconds / (3600 * 24)),
      hours: Math.floor((diffInSeconds % (3600 * 24)) / 3600),
      minutes: Math.floor((diffInSeconds % 3600) / 60),
      seconds: diffInSeconds % 60,
    };
  }else{
    return {
      days:0,
      hours:0,
      minutes:0,
      seconds:0
    }
  }
  }

  useEffect(() => {
    // 1-second delay before the first update
    const timeout = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());

      // Now start the interval to update every second
      const timer = setInterval(() => {
        setTimeLeft(calculateTimeLeft());
      }, 1000);

      return () => clearInterval(timer); // Cleanup on unmount
    }, 1000);
    

    return () => clearTimeout(timeout); // Cleanup on unmount
  }, [data]);

  
  
if(isOnline===false){
     return <NoNetwork/>
    }
  if (loading) {
    return <div style={{ textAlign: 'center' }}>Loading...</div>;
  }
   if(ipAllowed===false){
     return <IpBlocked/>;
    } 


  return (
    <> 
     
     
    <div
      className="main exam-pages"
      style={{
        backgroundImage: `url(${bg})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
      }}
    >

      <BrowserRouter>
        <Routes>
          <Route path="/" element={loggedIn ? <Home /> : <Navigate to="/login" />} />
          <Route path="/login" element={loggedIn ? <Navigate to="/"  /> : <Login />} />
          <Route path="/home/instructions" element={loggedIn ? <Instructions /> : <Navigate to="/login"/>} />
          <Route path="/home/exam" element={loggedIn ? <ExamPage /> : <Navigate to="/login" />} />
          <Route path="/home/exam-submitted" element={loggedIn ? <ExamSubmittedAlready /> : <Navigate to="/login" />} />



          <Route path="/home/exam-completed" element={loggedIn ? <ExamCompleted /> : <Navigate to="/login"/>} />

            <Route path="/home/exam/exam-submitted" element={loggedIn ? <ExamSubmittedAlready /> : <Navigate to="/login"/>} />




        </Routes>
      </BrowserRouter>

      {/* <ToastContainer /> */}
    </div>
    </>
  );
}

export default App;
